import { render, staticRenderFns } from "./SkyCard.vue?vue&type=template&id=71c7cf13&scoped=true"
import script from "./SkyCard.vue?vue&type=script&lang=js"
export * from "./SkyCard.vue?vue&type=script&lang=js"
import style0 from "./SkyCard.vue?vue&type=style&index=0&id=71c7cf13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c7cf13",
  null
  
)

export default component.exports